module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/121.f76db2cb.png";